import moment from "moment";
import { NumericFormat } from "react-number-format";
import banks from "./banks";
import { CUSTOMER_MONEY_FLOW_TYPE, INVENTORY_FUEL_CATEGORY, MONEY_TYPE } from "./Utils";
import { isPN } from "./feature-flag-key";
export const pnTransactionHistoryListColTable = ({
  actionCol = []
}) => [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "NH",
      accessor: (item) => item.bankAccount?.name
    },
    {
      Header: "KH/NCC",
      accessor: (item) => item.customer?.name
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content || "",
    },
    {
      Header: "Danh mục",
      accessor: (item) => item?.category?.name || "",
    },
    {
      Header: "Tiền thu(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item.contractId || '',
    },
    ...actionCol
  ]


export const pnCustomerMoneyFlowListColTable = () => [
  {
    Header: "Mã",
    accessor: (item) => item.id,
  },
  {
    Header: "Ngày",
    accessor: (item) => item.date,
  },
  {
    Header: "Tên KH/NCC",
    accessor: (item) => item.customer?.name,
  },
  {
    Header: "Tài khoản",
    accessor: (item) => item.bankAccount?.name,
  },
  {
    Header: "Danh mục",
    accessor: (item) => item?.transactionHistory?.category?.name,
  },
  {
    Header: "Xe",
    accessor: (item) => item?.transactionHistory?.truckId || item.truckId,
  },
  {
    Header: "Loại",
    accessor: (item) => CUSTOMER_MONEY_FLOW_TYPE[item?.type],
  },

  {
    Header: "Nội dung",
    accessor: (item) => item?.transactionHistory?.content || item?.content,
  },
  {
    Header: "Tiền thu(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item?.inAmount || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Tiền chi(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item?.outAmount || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
];


export const pnStaffMoneyFlowListColTable = ({
  actionCol = []
}) => [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date, 'YYYY-MM-DD').format('DD-MM-YYYY'),
    },
    {
      Header: "Nhân viên",
      accessor: (item) => item?.pnStaff?.name,
    },
    {
      Header: "Xe",
      accessor: (item) => item?.truckId,
    },

    {
      Header: "Danh mục",
      accessor: (item) => item?.pnCategory?.name,
    },

    {
      Header: "Loại",
      accessor: (item) => MONEY_TYPE[item.type],
    },
    {
      Header: "Số tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.amount}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand"
      />,
    },
    {
      Header: "Nội dung",
      accessor: "content",
    },
    {
      Header: "Ghi chú",
      accessor: "note",
    },
    {
      Header: "Xác nhận",
      className: 'action-col',
      accessor: (item) => item.agreedAt ? <span>Đã xác nhận</span> : <span>Chưa xác nhận</span>
    },
    ...actionCol
  ]

export const inventoryInColTable = ({
  actionCol = []
}) => [
    {
      Header: "Tại kho",
      accessor: (item) => item?.warehouse?.name,
    },
    {
      Header: "Loại",
      accessor: (item) => INVENTORY_FUEL_CATEGORY[item.category],
    },
    {
      Header: "Số lượng nhiên liệu(lít)",
      className: 'text-right',
      accessor: (item) => item.quantity,
    },
    {
      Header: "Đơn giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.unitPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Ngày tạo",
      accessor: (item) =>
        moment(item.date).format("DD/MM/YYYY HH:mm") || "",
    },
    ...actionCol
  ]


export const inventoryOutInsideColTable = ({
  actionCol = []
}) => [
    {
      Header: "Biển số xe",
      accessor: (item) => item.truckId || "",
    },
    {
      Header: "Số lượng dầu(lít)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.quantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Đơn giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.unitPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.price || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tài xế",
      accessor: (item) => item?.user?.name || "",
    },

    {
      Header: "Tại kho",
      accessor: (item) => item?.warehouse?.name,
    },
    {
      Header: "Ngày tạo",
      accessor: (item) =>
        moment(item.date).format("DD/MM/YYYY HH:mm:ss") || "",
    },
    ...actionCol
  ]



export const bankHoookTransactionColTable = ({
  actionCol = []
}) => [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Ngày tạo",
      accessor: (item) => moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')
    },
    {
      Header: "Ngân hàng",
      accessor: (item) => banks.find(bank => bank.code === item.bankCode)?.shortName
    },
    {
      Header: "STK",
      accessor: (item) => item.bankNumber
    },
    {
      Header: "Số tiền(đ)",
      accessor: (item) => <NumericFormat
        displayType='text'
        value={item?.amount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Số GD nội bộ(đ)",
      accessor: (item) => <NumericFormat
        displayType='text'
        value={item?.transactionHistoryCount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Số tiền nội bộ(đ)",
      accessor: (item) => <NumericFormat
        displayType='text'
        value={item?.transactionHistoryTotal || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Loại",
      accessor: (item) => MONEY_TYPE[item.type],
    },
    {
      Header: "Nội dung",
      accessor: (item) => item?.content,
    },
    ...actionCol
  ]

export const transactionHistoryColTable = () => [
  {
    Header: "Ngày",
    accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
  },
  {
    Header: "KH/NCC",
    accessor: (item) => item.customer?.name
  },
  {
    Header: "Nội dung",
    accessor: (item) => item?.content || "",
  },
  {
    Header: "Danh mục",
    accessor: (item) => item?.category?.name || "",
  },
  {
    Header: "Tiền thu(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.inAmount}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Tiền chi(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.outAmount}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Tồn(đ)",
    className: 'text-right',
    accessor: (item) => <NumericFormat
      displayType={"text"}
      value={item.lessAmount || 0}
      thousandsGroupStyle="thousand"
      thousandSeparator=","
      decimalScale={2}
    />
  },
  {
    Header: "Hợp đồng",
    accessor: (item) => item.contractId || '',
  },
  ...(isPN
    ? []
    : [{
      Header: "Tiền thu($)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmountUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền chi($)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmountUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tồn($)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lessAmountUSD || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tỉ giá",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.exchangeRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },]),
  {
    Header: "Ghi chú",
    accessor: () => "",
  },
]